import { render, staticRenderFns } from "./parent.vue?vue&type=template&id=e709ac4e&scoped=true"
import script from "./parent.vue?vue&type=script&lang=js"
export * from "./parent.vue?vue&type=script&lang=js"
import style0 from "./parent.vue?vue&type=style&index=0&id=e709ac4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e709ac4e",
  null
  
)

export default component.exports